<script setup lang="ts">
import { toastVariants } from '@satch-ui/primitives/toast/variants'

import { ToastLayout } from '@fond-of/fondof-ui'
import { CircleExclamationIcon } from '@fond-of/satch-icons'
</script>

<template>
  <ToastLayout
    :class="
      toastVariants({
        variant: 'danger',
      })
    "
  >
    <template #icon>
      <CircleExclamationIcon class="size-5.5" />
    </template>

    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
  </ToastLayout>
</template>
